import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { IconClose, IconPerson } from "../../icons/svg/index.js";
import GroupService from "../../services/group.js";
import AvatarList from '../avatar-list.jsx'
import Helpers from "../../lib/helpers.js";
import { NODE_TYPE_MESSAGE } from "../../tinode/constants.js";

const messages = defineMessages({
	join_group_info_title: {
		id: "join_group_info_title",
		defaultMessage: "Invite to join the group",
		description: "Invite to join the group",
	},
	another_member_count: {
		id: "another_member_count",
		defaultMessage: "{count} other members",
		description: "{count} other members",
	},
	join_group_link_desc: {
		id: "join_group_link_desc",
		defaultMessage: "Join the group to chat with everyone in the group",
		description: "Join the group to chat with everyone in the group",
	},
	join_group_link_button: {
		id: "join_group_link_button",
		defaultMessage: "Join the group",
		description: "Join the group",
	},
	already_request_link_button: {
		id: "already_request_link_button",
		defaultMessage: "Participation request has been sent",
		description: "Participation request has been sent",
	},
	notify_error: {
		id: "notify_error",
    defaultMessage: "An error occurred. Please try again later",
    description: "Notify error"
  },
	notify_error: {
		id: "notify_error",
    defaultMessage: "An error occurred. Please try again later",
    description: "Notify error"
  },
	add_pending_member_success: {
		id: "add_pending_member_success",
    defaultMessage: "Put on waiting list success.",
    description: "Put on waiting list success."
  },
	already_member: {
		id: "already_member",
    defaultMessage: "You are already a member of the group.",
    description: "You are already a member of the group."
  },
	group_need_at_least_one_admin: {
		id: "group_need_at_least_one_admin",
    defaultMessage: "The group does not have an administrator to approve new members joining the group.",
    description: "The group does not have an administrator to approve new members joining the group."
	}
})

export const JOIN_GROUP_STATE = {
	NOT_YET_JOINED: 0,
	ALREADY_REQUESTED: 1,
	ALREADY_MEMBER: 2,
}

export const REQUEST_JOIN_GROUP_STATE = {
	REQUEST_SUCCESS: 0,
	ALREADY_IN_REQUEST_LIST: 1,
	ALREADY_MEMBER: 2,
	ADD_TO_MEMBER_SUCCESS: 3,
	GROUP_DOES_NOT_HAVE_ADMIN: 4,
	REQUEST_FAILED: 5,
}

class JoinGroupInfo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {}

		this.onJoinGroup = this.onJoinGroup.bind(this)
		this.renderContent = this.renderContent.bind(this)
	}

	componentDidMount() {

	}

	async onJoinGroup() {
		const { formatMessage } = this.props.intl;
		const { groupId } = this.props

		const addResult = await GroupService.addPendingMember(groupId)

		if (addResult && addResult?.code === 200) {
			switch (addResult.errorCode) {
				case REQUEST_JOIN_GROUP_STATE.REQUEST_SUCCESS: {
					Helpers.showSuccessToasts(formatMessage(messages.add_pending_member_success))
					break
				}
				case REQUEST_JOIN_GROUP_STATE.ALREADY_IN_REQUEST_LIST: {
					Helpers.showWarningToasts(formatMessage(messages.already_request_link_button))
					break
				}
				case REQUEST_JOIN_GROUP_STATE.ALREADY_MEMBER: {
					Helpers.showWarningToasts(formatMessage(messages.already_member))
					const topicId = MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.GROUPCHAT, groupId)
					this.props.onTopicSelected(topicId)
					break
				}
				case REQUEST_JOIN_GROUP_STATE.GROUP_DOES_NOT_HAVE_ADMIN: {
					Helpers.showErrorToasts(formatMessage(messages.group_need_at_least_one_admin))
					break
				}
				case REQUEST_JOIN_GROUP_STATE.REQUEST_FAILED: {
					Helpers.showErrorToasts(formatMessage(messages.notify_error))
					break
				}
			}

			this.props.onClose()
		}
	}

	renderContent() {
		const { formatMessage } = this.props.intl;

		const { total_member, subject, state, member, owner } = this.props

		let button = ''

		switch (state) {
			case JOIN_GROUP_STATE.NOT_YET_JOINED: {
				button = (<button className="join-button request" onClick={this.onJoinGroup}>{formatMessage(messages.join_group_link_button)}</button>)
				break
			}
			case JOIN_GROUP_STATE.ALREADY_REQUESTED: {
				button = (<button className="join-button already-request" disabled>{formatMessage(messages.already_request_link_button)}</button>)
				break
			}
		}

		const members = owner.concat(member)
		const avatars = members.map((m) => {
			return Helpers.getAvatarURL(m.msisdn, m.lastAvatar)
		})

		return (
			<div className="content">
				<div className="avatar-container"><div className="avatar-group"><IconPerson /></div></div>
				<div className="group-name">{subject}</div>
				<div className="avatar-member-container">
					<AvatarList
						avatars={avatars}
						maxShow={3}
					/>
				</div>
				<div className="member-count">{formatMessage(messages.another_member_count, { count: total_member })}</div>
				<div className="invite-desc">{formatMessage(messages.join_group_link_desc)}</div>
				{button}
			</div>
		)

	}

	render() {
		const { formatMessage } = this.props.intl;

		return (
			<Suspense
				fallback={
					<div className="panel-form-row">
						<FormattedMessage
							id="loading_note"
							defaultMessage="Loading..."
							description="Message shown when component is loading"
						/>
					</div>
				}>
				<div className="dialog-join-group-info">
					<div className="header">
						<div className="title">
							{formatMessage(messages.join_group_info_title)}
						</div>
						<div className="icon" onClick={this.props.onClose}>
							<IconClose />
						</div>
					</div>
					{this.renderContent()}
				</div>
			</Suspense>
		)
	}
}

export default injectIntl(JoinGroupInfo);